import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom';
import { Input, Row, Form, Col, notification, Button, Modal, Popover } from 'antd';
import { KeyOutlined } from '@ant-design/icons';
import RequestHandler from '../../util/RequestHandler';

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 8,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const Change = (props) => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState();

  const [loadingBtn, setLoadingBtn] = useState(false);
  const [smsOtpValue, setSmsOtpValue] = useState("");
  const [loadingErp, setLoadingErp] = useState(false);
  const { initialMinute = 0 } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(180);
  const [errorText, setErrorText] = useState("");
  const [securityImage, setSecurityImage] = useState();
  const [securityModal, setSecurityModal] = useState({ visible: false, images: [] });

  const ref = useRef();
  const [form] = Form.useForm();
  const [formErp] = Form.useForm();

  const showModal = () => {
    setSeconds(180);
    setSmsOtpValue("");
    setErrorText("");

    RequestHandler.get(`/Auth/UserSecurityImages`).then(response => {
      if (response.success) {
        setSecurityImage(response.data[0]);
        setSecurityModal({ visible: true, images: response.data });
      }
    });
  }

  const openNotificationWithErpIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Erp kullanıcı kayıt işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const onFinishErp = (values) => {
    RequestHandler.post(
      `/Auth/UpdateLogoUserInfos`,
      {
        logoUsername: values.logoUserName,
        logoPassword: values.logoPassword,
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        openNotificationWithErpIcon("success");
        setTimeout(() => {
          setLoadingErp(false);
          window.location.reload();
        }, 2000);
      } else {
        setLoadingErp(false);
      }
    });
  };

  const onFinishErpFailed = () => setLoadingErp(false);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          handleCancel()
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000)
    return () => {
      clearInterval(myInterval);
    };
  });

  const openNotificationWithIcon = type => {
    notification[type]({
      message: "BAŞARILI",
      description: "Şifre güncelleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const openNotificationOldNewPasswordWarning = type => {
    notification[type]({
      message: "BAŞARILI",
      description: "Erp kullanıcı kayıt işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const onChangeSmsOtpValue = (e) => {
    setErrorText("");
    setSmsOtpValue(e.target.value);
  }

  const onSuccess = () => {
    openNotificationWithIcon('success');
    setTimeout(() => history.push(`/home`), 1000);
  }

  const handleSubmit = (values) => {
    RequestHandler.post(`/Auth/ChangePassword`, { ...values, ...formValues, securityImage: securityImage }, false, { rawResponse: true }).then((response) => {
      if (response.status == 200) {
        onSuccess();
      }
    });
  }

  const handleCancel = () => {
    if (handleCancel) {
      setLoading(false);
    }
    setSecurityModal({ ...securityModal, visible: false });
    setLoadingBtn(false);
  };

  const onFinish = values => {
    if (values.newPassword !== values.newPasswordAgain) {
      openNotificationOldNewPasswordWarning('error');
      setLoading(false);
      return;
    }

    RequestHandler.post(`/Auth/ChangePassword`, values, false).then(response => {
      if (response.success) {
        if (response.data === null) {
          setFormValues(values);
          showModal();
          return;
        }

        onSuccess();
      }
      setLoading(false);
    });
  };

  return (
    <div>
      <Row>
        <Col span={24}>
          <p style={{ fontSize: "200%" }}>
            {" "}
            <KeyOutlined /> ŞİFRE GÜNCELLE
          </p>{" "}
          <hr></hr>
          <br></br>
        </Col>
      </Row>
      <Form
        {...layout}
        name="basic"
        style={{ width: "100%" }}
        initialValues={{
          remember: true,
        }}
        form={form}
        onFinish={onFinish}
        onFinishFailed={() => setLoading(false)}
        autoComplete="off"
      >
        <Row>
          <Col span={24}>

            <Form.Item
              label="Eski Şifre"
              name="oldPassword"
              rules={[
                {
                  required: true,
                  message: "Lütfen eski şifre alanını boş bırakmayın.",
                },
              ]}
            >
              <Input className="gx-input-password" onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} autoComplete="off" />
            </Form.Item>

            <Form.Item
              label="Yeni Şifre"
              name="newPassword"
              rules={[
                {
                  required: true,
                  message: "Lütfen yeni şifre alanını boş bırakmayın.",
                },
              ]}
            >
              <Input className="gx-input-password" onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} autoComplete="off" />
            </Form.Item>

            <Form.Item
              label="Yeni Şifre Tekrar"
              name="newPasswordAgain"
              rules={[
                {
                  required: true,
                  message: "Lütfen şifre tekrar alanını boş bırakmayın.",
                },
              ]}
            >
              <Input className="gx-input-password" onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} autoComplete="off" />
            </Form.Item>
          </Col>
        </Row>


      </Form>
      <Form {...layout}
        name="basic"
        style={{ width: "100%" }}
        initialValues={{
          remember: true,
        }}
        form={formErp}
        onFinish={onFinishErp}
        onFinishFailed={onFinishErpFailed}>
        <Row>
          <Col span={24}>
            <p style={{ fontSize: "200%" }}>
              {" "}
              <KeyOutlined /> ERP KULLANICI BİLGİSİ
            </p>{" "}
            <hr></hr>
            <br></br>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label="Kullanıcı Adı"
              name="logoUserName"
              rules={[
                {
                  required: true,
                  message: "Lütfen logo kullanıcı adını boş bırakmayın.",
                },
              ]}
            >
              <Input autoComplete="off" />
            </Form.Item>
            <Form.Item
              label="Şifre"
              name="logoPassword"
              rules={[
                {
                  required: true,
                  message: "Lütfen logo şifre alanını boş bırakmayın.",
                },
              ]}
            >
              <Input
                onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()}
              />
            </Form.Item>
          </Col>
          <Col span={16}></Col>
          <Col span={8}>
            <Form.Item {...tailLayout} >
              <Button type="primary" htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                Güncelle
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Modal
        maskClosable={false}
        visible={securityModal.visible}
        onOk={() => {
          setLoadingBtn(true);
          form.submit();
        }}
        okText="Onayla"
        okButtonProps={{ loading: loadingBtn }}
        keyboard={false}
        cancelButtonProps={{ hidden: true }}
        onCancel={handleCancel}
      >

        <p style={{ margin: "5px 0", textAlign: 'center', fontSize: 16 }}>Mevcut Güvenlik Resmi:</p>
        <Row justify="center">
          {securityModal.images.length > 0 && (
            <a onClick={() => setSecurityImage(securityModal.images[0])}>
              <img
                src={`${RequestHandler.getApiUrl()}/Auth/SecurityImages/${securityModal.images[0]}`}
                alt=''
                style={securityImage === securityModal.images[0] ? {
                  width: 100,
                  opacity: 0.6,
                  border: "2px solid"
                } : {
                  width: 100
                }}
              />
            </a>
          )}
        </Row>

        <p style={{ marginTop: 10, textAlign: 'center', fontSize: 16 }}>Güvenlik resmini değiştirmek için aşağıdaki resimlerden birini seçebilir ya da mevcut güvenlik resminizi seçebilirsiniz.</p>
        <Row justify="center">
          <Col style={{ width: 300 }}>
            <Row gutter={5}>
              {
                securityModal.images.slice(1).map(imgSrc => (
                  <Col key={imgSrc} span={8} style={{ margin: "2.5px 0" }}>
                    <a onClick={() => setSecurityImage(imgSrc)}>
                      <img
                        src={`${RequestHandler.getApiUrl()}/Auth/SecurityImages/${imgSrc}`}
                        alt=""
                        style={securityImage === imgSrc ? {
                          width: 100,
                          opacity: 0.6,
                          border: "2px solid"
                        } : {
                          width: 100
                        }}
                      />
                    </a>
                  </Col>
                ))
              }
            </Row>
          </Col>
        </Row>

        <p style={{ marginTop: 10, textAlign: 'center', fontSize: 16 }}>Lütfen telefonunuza gelen tek kullanımlık şifreyi <b>{seconds}</b> saniye içinde girin; </p>

        <Form
          onFinish={handleSubmit}
          fields={[
            { name: "Sms", value: smsOtpValue },
          ]}
          ref={ref}
          form={form}
        >
          <Form.Item
            name="securityKey"
          >
            <Input
              onChange={onChangeSmsOtpValue}
              type='text' maxLength={6}
              autoComplete="off"
              style={{ marginTop: 40 }}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
                if (event.key === "Enter") {
                  setLoadingBtn(true);
                  ref.current.submit();
                }
              }}
            />
          </Form.Item>
        </Form>
        <p style={{ color: 'darkred', textAlign: 'center', fontWeight: 600 }}>{errorText}</p>
      </Modal>

    </div >
  )
}
export default Change